import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";

import { cloneStoryboard, invalidateStoryboardState } from "actions/storyboard";

import _ from 'lodash';
import cx from 'classnames';
import { getBaseUrl } from "services/util";

import styles from './clone.module.scss';

export const CloneStoryboardPage = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  let { storyboard } = useParams();
  const { search } = useLocation();

  const cloning = useSelector(state => _.get(state, 'storyboards.storyboard.cloning'));
  const clonedStoryboard = useSelector(state => _.get(state, 'storyboards.storyboard.item'));

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const list = urlParams.get('list');

    dispatch(cloneStoryboard(storyboard, list));
  }, []);

  useEffect(() => {
    if(!cloning && clonedStoryboard){
      if(window.opener){
        window.opener.location.reload();
      }

      dispatch(invalidateStoryboardState());

      const page = _.get(clonedStoryboard, 'page.id');
      var url = `${baseUrl}/pages/${page}`;
      history.replace(url);
    }
  }, [cloning, clonedStoryboard]);
  
  return (
    <div className={cx(styles.cloneStoryboard, styles.loading)}>
      Cloning storyboard....
    </div>
  );
}